<template>
  <div class="app-error">
    <app-header />
    <div class="app-error-content">
      <div class="error-view">
        <img class="error-image" src="/img/app-error-icon.svg" alt="" />
        <div class="error-title">{{ errorTitle }}</div>
        <div class="error-explanation">{{ errorExplanation }}</div>
        <div class="error-solution">{{ errorSolution }}</div>
        <app-link
          :label="$t('form.button.back')"
          @click="navigateAwayFromError"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { resolveContextDomain } from '@rready/composables';
import { AppNavigation } from '@rready/integration';
import AppHeader from './components/structure/AppHeader.vue';

type ErrorCode =
  | 'unknown'
  | 'invalid-context'
  | 'invalid-product'
  | 'cannot-resolve-product'
  | 'invalid-permission';

export default defineComponent({
  components: {
    AppHeader
  },
  computed: {
    errorCode(): ErrorCode {
      return (this.$route.params.errorCode as ErrorCode) ?? 'unknown';
    },
    errorTitle(): string {
      return this.getError(
        this.errorCode,
        'title',
        this.$route.query as Record<string, string>
      );
    },
    errorExplanation(): string {
      return this.getError(
        this.errorCode,
        'explanation',
        this.$route.query as Record<string, string>
      );
    },
    errorSolution(): string {
      return this.getError(
        this.errorCode,
        'solution',
        this.$route.query as Record<string, string>
      );
    }
  },
  methods: {
    getError(code: string, key: string, params: Record<string, string>) {
      return this.$t(`app-error.code.${code}.${key}`, params).toString();
    },
    navigateAwayFromError(): void {
      if (this.errorCode === 'invalid-context') {
        const contextDomain = resolveContextDomain(window.location);
        const url = AppNavigation.authLoginUrl('portal', contextDomain, '/');
        window.location.replace(url);
      }

      this.$router.push({ name: 'Home' });
    }
  }
});
</script>

<style lang="scss" scoped>
.app-error-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: calc(70px + 50px);
}

.error-view {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  width: 100%;
  max-width: 700px;
  padding: 12px;
  text-align: center;

  .error-image {
    height: 110px;
    width: 110px;
  }
  .error-title {
    color: black;
    font-size: 18px;
    font-weight: 600;
  }
  .error-explanation {
    color: #999999;
    font-size: 14px;
    font-weight: 400;
  }
  .error-solution {
    color: #999999;
    font-size: 14px;
    font-weight: 400;
  }
}
</style>
